import { memo } from 'react'
import { useShallow } from 'zustand/react/shallow'
import { useGlobalStore } from '../../../store/global-store'
import { Toast } from './components/toast'
import { useUpdateToastEarnedGlobal } from './use-update-toast-earned-global'

export const ToastEarnedGlobal = memo(() => {
  useUpdateToastEarnedGlobal()

  const notifyGiftListToastEarned = useGlobalStore(
    useShallow((state) => state.notifyGiftListToastEarned),
  )
  return (
    <div className="w-screen h-screen flex items-center flex-col gap-2 ">
      {notifyGiftListToastEarned?.map(
        (toast, index) => index === 0 && <Toast key={toast.id} item={toast} />,
      )}
    </div>
  )
})
